function createLatestComputation(definition, changed) {
  var executor = definition.createExecutor();
  var revision = 0;
  var disposed = false;
  var computing = false;
  var waiting = null;
  var result = null;
  var isCurrent = function isCurrent2(value) {
    return !disposed && value === revision;
  };
  async function drain() {
    computing = true;
    while (!disposed && waiting) {
      var request = waiting;
      waiting = null;
      try {
        var computed = await executor.execute(request, isCurrent);
        if ((computed === null || computed === void 0 ? void 0 : computed.revision) === request.revision && isCurrent(request.revision)) {
          result = computed;
          changed({
            phase: "ready",
            result: computed
          });
        }
      } catch (error) {
        if (isCurrent(request.revision)) changed({
          phase: "failed",
          revision: request.revision,
          error: error instanceof Error ? error : new Error(String(error))
        });
      }
    }
    computing = false;
  }
  return {
    update(input) {
      if (disposed) return;
      revision++;
      result = null;
      waiting = {
        revision,
        input
      };
      changed({
        phase: "computing",
        revision
      });
      if (!computing) void drain();
    },
    getCurrent: function getCurrent() {
      return result;
    },
    dispose() {
      if (disposed) return;
      disposed = true;
      result = null;
      waiting = null;
      executor.dispose();
    }
  };
}
export {
  createLatestComputation
};
//# sourceMappingURL=createLatestComputation.js.map
